import React, { useState, useEffect, useCallback } from 'react'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import { actionButtonsColumnProps, BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import { actionCreators } from '@/store/dataCrossing'
import { actionCreators as dialogActionCreators } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'
import { TabContent, TabNavItems, TabPane } from '@/components/tabs'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { push } from 'react-router-redux'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { DoubleDateCell } from '@/components/BsrsGrid/dateCells'

export const duplicatesTabs = {
  possibleDuplicates: 'possibleDuplicates',
  duplicateList: 'duplicateList'
}

export const DataCrossingDuplicates = React.memo(function DataCrossingDuplicates (props) {
  const { localize, locale } = useLocalization()
  const [reloadAt, setReloadAt] = useState(new Date())
  const tabId = props.match.params.tabId || duplicatesTabs.possibleDuplicates
  const isGranted = usePermissionChecker()

  const [clearDataCrossings, openDialog, routerPush] = useDispatch([
    actionCreators.clearDataCrossings,
    dialogActionCreators.openDialog,
    push
  ])

  useEffect(() => {
    clearDataCrossings()
  }, [clearDataCrossings])

  const onAddNewDuplicityClick = useCallback(() => {
    openDialog({
      dialogType: dialogTypes.addIndividualDuplicity,
      title: 'DataCrossings.AddNewDuplicity',
      primaryButtonText: 'DataCrossings.MarkAsDuplicity',
      onAction: ({ individualId, secondIndividualId }) => {
        context.api.dataCrossingService.setIndividualComparison({ id: individualId, secondId: secondIndividualId, isSameIndividual: true, isMarkedManually: true }).then(() => {
          setReloadAt(new Date())
        }).catch(() => setReloadAt(new Date()))
      }
    })
  }, [openDialog])

  const toggle = useCallback((id) => {
    routerPush(`/data-crossings-duplicates/${id === duplicatesTabs.possibleDuplicates ? duplicatesTabs.possibleDuplicates : duplicatesTabs.duplicateList}`)
  }, [routerPush])

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='DataCrossings.DuplicitiesTitle' />
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <WhiteBox>
          <TabNavItems activeTabId={tabId} onClick={toggle} items={[
            { id: duplicatesTabs.possibleDuplicates, text: 'DataCrossings.PossibleDuplicities' },
            { id: duplicatesTabs.duplicateList, text: 'DataCrossings.DuplicityList' }
          ]} />
          <TabContent activeTab={tabId}>
            <TabPane tabId={duplicatesTabs.possibleDuplicates}>
              <BsrsGrid persistenceId={'data-crossing-duplicates'} dataSource={request => context.api.dataCrossingService.getDuplicates(request)} lastReloadedAt={reloadAt}>
                <Column field='accordanceWeight' filter='numeric' title={localize('DataCrossings.AccordanceWeight')} />
                <Column field='name' title={localize('DataCrossings.Name')} />
                <Column field='surname' title={localize('Individuals.Surname')} />
                <Column field='fatherName' title={localize('Individuals.FatherName')} />
                <Column field='grandfatherName' title={localize('Individuals.GrandfatherName')} />
                <Column field='greatGrandfatherName' title={localize('Individuals.GreatGrandfatherName')} />
                <Column field='birthDate' title={localize('DataCrossings.BirthDate')} filter='date' cell={DoubleDateCell} filterCell={DateFilterCell} />
                {NameColumn({ nameProp: 'institutionsName', latinNameProp: 'institutionsLatinName', locale, title: localize('DataCrossings.Institution'), editable: false })}
                {NameColumn({ nameProp: 'jobPositionsName', latinNameProp: 'jobPositionsLatinName', locale, title: localize('DataCrossings.JobPosition'), editable: false })}
                <Column {...actionButtonsColumnProps([
                  {
                    url: x => `/data-crossings-duplicates/comparison-detail/${x.id}`,
                    icon: 'show'
                  }])} />
              </BsrsGrid>
            </TabPane>
            <TabPane tabId={duplicatesTabs.duplicateList}>
              {isGranted('CanManageDataCrossingsDuplicates') && <p className='btn-group'>
                <button className='btn btn-md btn-primary' onClick={onAddNewDuplicityClick}>
                  <Resx name='DataCrossings.AddNewDuplicity' /></button>
              </p>}
              <BsrsGrid persistenceId={'data-crossing-duplicate-list'} dataSource={request => context.api.dataCrossingService.getDuplicateList(request)} lastReloadedAt={reloadAt}>
                <Column field='name' title={localize('DataCrossings.Name')} width='320px' />
                <Column field='birthDate' title={localize('DataCrossings.BirthDate')} filter='date' cell={DateCell} filterCell={DateFilterCell} />
                <Column field='numberOfIndividuals' filter='numeric' title={localize('DataCrossings.NumberOfDuplicates')} />
                <Column {...actionButtonsColumnProps([
                  {
                    url: x => `/data-crossings-duplicates/duplicate-detail/${x.id}`,
                    icon: 'show'
                  }].filter(() => isGranted('CanManageDataCrossingsDuplicates')))} />
              </BsrsGrid>
            </TabPane>
          </TabContent>
        </WhiteBox>
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/duplicates.js